import Api from './apiHandler'
const BASE = 'auth'

const AuthApi = {
  signIn: (data) => Api.post(`${BASE}/login`, data),
  signUp: (data) => Api.post(`${BASE}/register`, data),
  authGoogle: (data) => Api.post(`${BASE}/auth-google`, data),
  forgotPassword: (data) => Api.post(`${BASE}/req-reset-password`, data),
  activateAccount: (data) => Api.post(`${BASE}/activate-account`, data),
  verifyResetPassword: (data) =>
    Api.post(`${BASE}/verify-reset-password`, data),
  resetPassword: (data) => Api.post(`${BASE}/reset-password`, data),
}

export default AuthApi
